// extracted by mini-css-extract-plugin
export default {"root":"invoiceHistory_root__d-kuS"};